import React from 'react'
import { Title } from '../helpers/Helper'
import { OfficeContainer, OfficeGrid, OfficeItem } from './officeStyle'
import * as data from './officeData'

export default function Office() {
  return (
    <OfficeContainer id='office'>
      <Title>Sucursales</Title>
      <OfficeGrid>
        {
          data.Location.map(({id, city, street, tel}) => {
            return(
              <OfficeItem key={id}>
                <h3>{city}</h3>
                <p>{street}</p>
                <span>{tel}</span>
              </OfficeItem>
            )
          })
        }
      </OfficeGrid>
    </OfficeContainer>
  )
}
